module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [(_vm.loading) ? _c('button', {
    staticClass: "btn btn-md btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin m-r-xs"
  })]) : _c('button', {
    staticClass: "btn btn-md btn-default",
    attrs: {
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-certificate m-r-xs"
  }), _vm._v(" Perícia "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu no-padder"
  }, _vm._l((_vm.items), function(item, key) {
    return _c('li', [_c('a', {
      attrs: {
        "tabindex": key
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.handleClick(item)
        }
      }
    }, [_c('i', {
      class: ("fa fa-" + (item.icon) + " fa-fw")
    }), _vm._v(" " + _vm._s(item.label) + " ")])])
  }), 0), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "uploadPericia",
    attrs: {
      "type": "file",
      "name": "files[]",
      "id": "fileInptImg",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.uploadDocumento
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64431a22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/roubo-furto/components/BtnMenuPericia.vue
// module id = 1724
// module chunks = 17